import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
} from '@chakra-ui/react';
import { Input } from '@/components/v4';
import { AutoResizeTextArea } from '@/components/v4/Textarea';
import { textBoxStyling } from 'components/forms/new/formStyles';

// Pairs a native input/textarea with ChipInsertPalette, tracking cursor position so a chip click can splice text in at the right offset.
const TextEditor = ({
    textfield = {},
    id = 'textfieldarea1',
    field,
    setCursorPosition,
    dataWalkthroughId,
    placeholder,
}) => {
    const inputRef = useRef();
    const dispatch = useDispatch();
    const {
        label,
        multiline = true,
        value,
        autoFocus,
        error,
        helperText,
        placeholder: fieldPlaceholder,
        onChange,
        onFocus,
        onBlur,
        ...rest
    } = textfield;

    const handleSelect = () =>
        setCursorPosition(inputRef.current?.selectionStart);

    const handleChange = (e) => {
        onChange?.(e);
        setCursorPosition(inputRef.current?.selectionStart);
    };

    const handleFocus = (e) => {
        dispatch({
            type: 'CHANGE_MODAL_STATE',
            payload: { activeTextareaID: id, activeTextareaField: field },
        });
        setCursorPosition(inputRef.current?.selectionStart);
        onFocus?.(e);
    };

    const sharedProps = {
        id,
        value,
        autoFocus,
        placeholder: fieldPlaceholder ?? placeholder,
        onSelect: handleSelect,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur,
        'data-walkthroughid': dataWalkthroughId,
        ...rest,
    };

    return (
        <FormControl isInvalid={!!error}>
            {label && <FormLabel>{label}</FormLabel>}
            {multiline ? (
                <AutoResizeTextArea
                    ref={inputRef}
                    minRows={5}
                    {...sharedProps}
                />
            ) : (
                <Input
                    customRef={inputRef}
                    sx={textBoxStyling}
                    {...sharedProps}
                />
            )}
            {error && helperText ? (
                <FormErrorMessage>{helperText}</FormErrorMessage>
            ) : (
                helperText && <FormHelperText>{helperText}</FormHelperText>
            )}
        </FormControl>
    );
};

export default TextEditor;
